import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane, AccordionBody, AccordionHeader, AccordionItem, Accordion } from "reactstrap";
import "moment-timezone";
import "moment/locale/id";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetHandoverListState, getHandoverList } from "../../../store/handoverList/action";
import { resetProductState, getProduct } from "../../../store/product/action";
import { resetProductComplainState, getProductComplain as onGetProductComplain, addNewProductComplain as onAddNewProductComplain, updateProductComplain as onUpdateProductComplain, deleteProductComplain as onDeleteProductComplain, getProductComplainLoading, resetProductComplainCreateState } from "../../../store/productComplain/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetClientState, getClient } from "../../../store/client/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";

const ProductComplain = (props) => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalMediaApplicationDoc, setModalMediaApplicationDoc] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, productComplains, isProductComplainCreated, isProductComplainUpdate, isProductComplainSuccess, loading, error, products, productLoading, handoverLists, handoverListLoading, companies, companyLoading, branches, branchLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    productComplains: state.ProductComplain.productComplains,
    loading: state.ProductComplain.loading,
    isProductComplainCreated: state.ProductComplain.isProductComplainCreated,
    isProductComplainUpdate: state.ProductComplain.isProductComplainUpdate,
    isProductComplainSuccess: state.ProductComplain.isProductComplainSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    handoverLists: state.HandoverList.handoverLists,
    handoverListLoading: state.HandoverList.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.ProductComplain.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    products: state.Product.products,
    productLoading: state.Product.loading,
  }));

  const [productComplainList, setProductComplainList] = useState([]);
  const [productComplainEngineeringList, setProductComplainEngineeringList] = useState([]);
  const [productComplainDoc, setProductComplainDoc] = useState([]);
  const [productComplain, setProductComplain] = useState(null);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [handoverListList, setHandoverListList] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [checkComplainList, setCheckComplainList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchBranch, setSearchBranch] = useState("");

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditApllicationDoc, setIsEditApllicationDoc] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setProductComplainList(productComplains);
  }, [productComplains]);

  useEffect(() => {
    if (branchSelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetProductComplainState());
      dispatch(onGetProductComplain({ branchId: branchSelected?.value ?? "" }));
      handleGetProduct(userData?.companyId);
      handleGetHandoverList(userData?.companyId);
    }
  }, [branchSelected]);

  const handleGetHandoverList = (id) => {
    dispatch(resetHandoverListState());
    dispatch(getHandoverList({ companyId: id, status: 2 }));
  };

  const handleGetProduct = (companyId) => {
    dispatch(resetProductState());
    dispatch(getProduct({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(productComplains)) {
      setProductComplainList(productComplains.map((el) => ({ ...el, isChecked: false })));
      setInfo(productComplains[productComplains.length - 1]);
    }
  }, [productComplains]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "progress-dev",
        label: "Progres Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "debitur",
        label: "Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "marketing",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
      {
        id: "blok",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "tgl_akad",
        label: "Tanggal Akad",
        isSelected: true,
        data: [],
      },
      {
        id: "bank",
        label: "Bank",
        isSelected: true,
        data: [],
      },
    ];
    const docDataCustom = handoverLists.map((el) => ({
      id: el.id,
      label: el.name,
      isSelected: true,
      data: [],
    }));

    const dataDocMerge = [...dataDoc, ...docDataCustom];

    if (productComplainList.length > 0) {
      productComplainList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            // const doc = dataDoc.find((d) => d.id === key);

            if (key === "product_sales") {
              const progressDev = "-";
              const debitur = Array.isArray(value) && value[0]?.sls_ds?.sales_customer?.name?.trim() ? value[0].sls_ds.sales_customer.name : "-";
              const marketing = Array.isArray(value) && value[0]?.sls_ds?.sales_agent?.name?.trim() ? value[0].sls_ds.sales_agent.name : "-";
              const blok = Array.isArray(value) && value[0]?.sls_ds?.blok?.trim() ? value[0].sls_ds.blok : "-";
              const completeAt = Array.isArray(value) && value[0]?.sls_ds?.completedat?.trim() ? value[0].sls_ds.completedat : "-";
              const bank = "-";

              const progressDevDoc = dataDocMerge.find((d) => d.id === "progress-dev");
              const debiturDoc = dataDocMerge.find((d) => d.id === "debitur");
              const marketingDoc = dataDocMerge.find((d) => d.id === "marketing");
              const blokDoc = dataDocMerge.find((d) => d.id === "blok");
              const completeAtDoc = dataDocMerge.find((d) => d.id === "tgl_akad");
              const bankDoc = dataDocMerge.find((d) => d.id === "bank");
              const handoverProdIds = (data.handover_complain || []).flat().map((item) => item.id?.toString());

              const size = docDataCustom.length;

              const result = [];
              for (let i = 0; i < handoverProdIds.length; i += size) {
                result.push(handoverProdIds.slice(i, i + size));
              }

              // for (const el of handoverLists) {
              //   const doc = dataDocMerge.find((d) => d.id.toString() === el.id.toString());

              //   if (!doc) continue;
              //   const arr = handoverProdIds.map((id) => (id === el.id.toString() ? "✓" : "✗"));

              //   doc.data.push(arr.join(","));
              // }

              progressDevDoc.data.push(progressDev);
              debiturDoc.data.push(debitur);
              marketingDoc.data.push(marketing);
              blokDoc.data.push(blok);
              completeAtDoc.data.push(completeAt);
              bankDoc.data.push(bank);

              result.forEach((group, idx) => {
                if (idx > 0) {
                  progressDevDoc.data.push("");
                  debiturDoc.data.push("");
                  marketingDoc.data.push("");
                  blokDoc.data.push("");
                  completeAtDoc.data.push("");
                  bankDoc.data.push("");
                }

                docDataCustom.forEach((doc) => {
                  const exist = group.some((e) => e.toString() === doc.id.toString());

                  doc.data.push(exist ? "✓" : "✗");
                });
              });
            }
          });
        }
      });
    }

    setProductComplainDoc(dataDocMerge);
  }, [productComplainList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(products)) {
      var data = [];
      var opt = [];
      products.forEach((item, key) => {
        const name = item.name;
        const branch = item.product_branch ? item.product_branch.name : "";
        const block = item.product_block ? item.product_block.name : "";
        const id = item.id;
        var obj = { label: block + " - " + name + " / " + branch, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setProductList(data);
    }
  }, [products]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const toggleBranch = (val) => {
    setSearchValue("");
    setFilterDate(null);
    dispatch(onGetProductComplain({ branchId: val }));
  };

  useEffect(() => {
    if (filerIdRef.current && branchList.length > 0) {
      const branchSelectedDefault = branchList[0].options.find((data) => data.value === filerIdRef.current.branchId);
      setSearchBranch(branchSelectedDefault);
    }
  }, [branchList]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProductComplain(null);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  useEffect(() => {
    if (isProductComplainCreated && companySelected.value) {
      dispatch(resetProductComplainState());
      dispatch(onGetProductComplain({ branchId: branchSelected?.value ?? "" }));
    }
  }, [isProductComplainCreated]);

  const handleProductComplainClick = useCallback(
    (arg, type) => {
      const data = arg;
      let arrComplain = [];
      if (data.handover_complain && data.handover_complain.length > 0) {
        data.handover = data.handover_complain;
      } else {
        for (const d of handoverLists) arrComplain.push({ id: 0, name: d.name, targetat: "", Aktualat: "", description: "" });
        data.handover = [...(data.handover || []), arrComplain];
      }
      setCheckComplainList(arrComplain);

      const branch = data.product_branch ? data.product_branch.name : "";
      const block = data.product_block ? data.product_block.name : "";

      data.productId = data.name ? { label: block + " - " + data.name + " / " + branch, value: data.id } : "";
      setProductComplain(data);
      setIsEdit(true);
      toggle();
    },
    [toggle, handoverLists],
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = productComplainList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setProductComplainList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 pe-0 me-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = productComplainList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setProductComplainList(updatedData);
                }}
              />
              <ButtonGroup className="m-0">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      // handleProductComplainClick(data, "detail");
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      setInfo(data);
                      handleProductComplainClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Unit",
        accessor: "name",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          return <div className="mb-1">{data.product_block?.name + " - " + data.name}</div>;
        },
      },
      {
        Header: "Blok",
        accessor: "product_block.name",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          return <div>{data.product_block?.name}</div>;
        },
      },
      {
        Header: "Proyek",
        accessor: "product_branch.name",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          return <div>{data.product_branch?.name}</div>;
        },
      },
      {
        Header: "Penjualan",
        accessor: "id",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          const sales = data.product_sales.length ? data.product_sales[0].sls_ds : null;
          const custName = sales && sales.sales_customer ? sales.sales_customer.name : "-";
          const agentName = sales && sales.sales_agent && <span className="badge text-uppercase badge-soft-info mt-1">{sales.sales_agent.name}</span>;
          return (
            <>
              <div>{custName}</div>
              {agentName}
            </>
          );
        },
      },
      {
        id: "Marketing",
        Header: "Marketing",
        accessor: "sales_agent.name",
        filterable: true,
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: false,
        Cell: (cell) => {
          let data = cell.row.original;
          const sales = data.product_sales.length ? data.product_sales[0].sls_ds : null;
          return sales && sales.transactionat ? handleValidDate(sales.transactionat) : "";
        },
      },
    ],
    [productComplainList, handleProductComplainClick, userRole, userType, isCheckAll],
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = productComplainList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setProductComplainList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => productComplainList, [productComplainList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Marketing", "Status", "Proyek", "Booking"],
        pageIndex: indexPage,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  function handleComplainAdd() {
    let arrComplain = [];
    for (const d of handoverLists) arrComplain.push({ id: 0, name: d.name, targetat: "", Aktualat: "", description: "" });
    validation.setFieldValue("handover", [...(validation.values.handover || []), arrComplain]);
  }

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "requested",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetProductComplain(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setProductComplainList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetProductComplainState());
    dispatch(onGetProductComplain({ branchId: branchSelected?.value ?? "" }));
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      productId: productComplain && productComplain.productId,
      handover: (productComplain && productComplain.handover) || [],
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {

      dispatch(getProductComplainLoading());
      if (values.productId.value > 0) {
        let editSubmit = {
          id: values.productId.value,
          handover_complain: values.handover,
        };
        dispatch(onUpdateProductComplain(editSubmit));
      } else {
        toast.error("Silahkan isi unit yang diserah terimakan", { position: "bottom-left", autoClose: 5000 });
      }
      validation.resetForm();
      toggle();
    },
  });

  document.title = "Keluhan Konsumen | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={productComplainList} />
      <Container fluid>
        <BreadCrumb title="BAST" pageTitle="Keluhan Konsumen">
          <div className="flex-shrink-0">
            <button
              type="button"
              className="btn btn-primary add-btn me-2"
              id="create-btn"
              onClick={() => {
                handleProductComplainClick([]);
              }}
            >
              <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={productComplainDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={7}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div className="border-top">
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            {/* <i className="bx bx-search-alt search-icon"></i> */}
                          </div>
                        </Col>

                        <Col sm={2}>
                          <div className="me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            {/* <i className="bx bx-calendar-alt search-icon"></i> */}
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1" style={{ minHeight: "320px" }}>
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Form Berita Acara Serah Terima" : "Form Berita Acara Serah Terima"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className="pt-0 pb-4 ps-4 pe-4">
                        <div className="mb-5">
                          <label className="form-label" htmlFor="productId">
                            Unit
                          </label>
                          <Select
                            name="productId"
                            placeholder="Pilih Unit"
                            value={validation.values.productId}
                            onChange={(e) => {
                              validation.setFieldValue("productId", e);
                            }}
                            options={productList}
                          ></Select>
                          {validation.touched.productId && validation.errors.productId && (
                            <small className="text-danger" type="invalid">
                              {validation.errors.productId}
                            </small>
                          )}
                        </div>
                        <div className="mb-3 position-relative">
                          <Label htmlFor="agencies_contact" className="form-label">
                            Komplain
                          </Label>
                          <button
                            type="button"
                            className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                            onClick={() => {
                              handleComplainAdd();
                            }}
                          >
                            <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                          </button>
                        </div>

                        {(validation.values.handover || []).map((el, index) => {
                          return (
                            <div key={index}>
                              {el.map((e, idx) => {
                                const findHandover = handoverLists.find((d) => d.name === e.name) || {};

                                return (
                                  <div key={idx} className="row ms-1">
                                    <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-3">
                                      <Input
                                        className={"form-check-input checked-all checked-method-all check-" + findHandover.id + idx}
                                        type="checkbox"
                                        role="switch"
                                        value={e.id}
                                        defaultChecked={findHandover.id === e.id && e.id !== 0 ? true : false}
                                        onChange={(e) => {
                                          console.log(findHandover);
                                          if (e.target.checked) validation.setFieldValue(`handover[${index}][${idx}].id`, findHandover.id);
                                          else validation.setFieldValue(`handover[${index}][${idx}].id`, 0);
                                        }}
                                      />
                                      <Label className="form-check-label text-dark text-uppercase" htmlFor={"check-" + findHandover.id + idx}>
                                        {e.name}
                                      </Label>
                                    </div>
                                    <div className="mb-2 col-lg-2">
                                      <Flatpickr
                                        className="form-control"
                                        placeholder="Target"
                                        options={{ mode: "single", dateFormat: "Y/m/d" }}
                                        onChange={(selectedDates, dateStr) => {
                                          validation.setFieldValue(`handover[${index}][${idx}].targetat`, dateStr);
                                        }}
                                        value={e.targetat}
                                      />
                                    </div>
                                    <div className="mb-2 col-lg-2">
                                      <Flatpickr
                                        className="form-control"
                                        placeholder="Aktual"
                                        options={{ mode: "single", dateFormat: "Y/m/d" }}
                                        onChange={(selectedDates, dateStr) => {
                                          if (validation.values.handover[index][idx]) validation.values.handover[index][idx].Aktualat = dateStr;
                                        }}
                                        value={e.Aktualat}
                                      />
                                    </div>
                                    <div className="mb-2 col-lg-5">
                                      <Input
                                        type="textarea"
                                        className="form-control"
                                        placeholder="Keterangan jika ada"
                                        value={e.description}
                                        onChange={(e) => {
                                          validation.setFieldValue(`handover[${index}][${idx}].description`, e.target.value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                              <div className="w-100 border-bottom mt-2 mb-3" />
                            </div>
                          );
                        })}

                        {/* {handoverLists.map((o, idx) => {
                          if (validation.values.handover.length > 0) {
                            return (
                              <div key={idx} className="row ms-1">
                                <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-3">
                                  <Input
                                    className={"form-check-input checked-all checked-method-all check-" + o.id + idx}
                                    type="checkbox"
                                    role="switch"
                                    value={validation.values.handover[idx]?.id}
                                    defaultChecked={o.id === validation.values.handover[idx]?.id && validation.values.handover[idx]?.id !== 0 ? true : false}
                                    onChange={(e) => {
                                      if (e.target.checked) validation.setFieldValue(`handover[${idx}].id`, o.id);
                                      else validation.setFieldValue(`handover[${idx}].id`, 0);
                                    }}
                                  />
                                  <Label className="form-check-label text-dark text-uppercase" htmlFor={"check-" + o.id + idx}>
                                    {o.name}
                                  </Label>
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Target"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue(`handover[${idx}].targetat`, dateStr);
                                    }}
                                    value={validation.values.handover[idx]?.targetat}
                                  />
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Aktual"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      if (validation.values.handover[idx]) validation.values.handover[idx].Aktualat = dateStr;
                                    }}
                                    value={validation.values.handover[idx]?.Aktualat}
                                  />
                                </div>
                                <div className="mb-2 col-lg-5">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Keterangan jika ada"
                                    value={validation.values.handover[idx]?.description}
                                    onChange={(e) => {
                                      validation.setFieldValue(`handover[${idx}].description`, e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          } else return null;
                        })} */}
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {"SIMPAN DATA"}&nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body">
                <h5 className="mb-4">
                  {info.product_block ? info.product_block.name + "-" + info.name : "-"} / {info.product_branch ? info.product_branch.name : "-"}
                </h5>
                <table className="table border table-responsive fs-13 mb-3">
                  <tbody>
                    <tr>
                      <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                        DATA KELUHAN
                      </td>
                    </tr>
                    {info.handover_complain &&
                      info.handover_complain.map((row, idx) => {
                        return (
                          <Fragment key={idx}>
                            <tr>
                              <td className="p2 border-top-0">
                                <span className="fw-semibold">
                                  <i className={row.id ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line text-danger me-1"}></i> {row.name ? row.name : "-"}
                                </span>
                                , {row.Aktualat ? row.Aktualat : "-"}
                              </td>
                            </tr>
                            {row.description && row.description !== "" && (
                              <>
                                <tr>
                                  <td className="p2 border-0">Keterangan : {row.description ? row.description : "-"}</td>
                                </tr>
                                <tr>
                                  <td className="p0 border-top-0"></td>
                                </tr>
                              </>
                            )}
                          </Fragment>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
ProductComplain.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ProductComplain));
